import React from 'react';
import ClassNames from 'classnames';
import { string, oneOf } from 'prop-types';

import { ReactComponent as Spinner } from '@assets/svg-icons/spinner.svg';

import './Loader.scss';

const Loader = ({ className, size, label }) => (
  <div
    aria-busy="true"
    aria-label={label}
    className={ClassNames('loader-spinner', className)}
    role="progressbar"
  >
    <Spinner
      className={ClassNames(
        'loader-spinner__module',
        `loader-spinner__module--${size}`
      )}
    />
  </div>
);

Loader.propTypes = {
  className: string,
  size: oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl']),
  label: string
};

Loader.defaultProps = {
  className: '',
  size: 'sm',
  label: 'loader'
};

export default Loader;
